import { gql } from "@stadium/services/apollo-client";

export const fetchWorkspaceBySlug = gql`
  query fetchWorkspaceBySlug($slug: String!) @api(name: "users") {
    workspace(slug: $slug) {
      id
      uuid
      subscription {
        id
        daysLeft
        status
      }
    }
    currentWorkspaceUser(slug: $slug) {
      id
      workspacePoints
      permissions
      teams {
        id
        name
        currencyCode
        myWalletBalance
        permissions
      }
    }
  }
`;
